import { useGalleryAnchor } from './useGalleryAnchor';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { RelatedObjects } from '@/components/object-relations/RelatedObjects';
import { DictionaryEditor } from '@/components/object-relations/DictionaryEditor';
import { AccessMatrix, ObjectVisibility } from '@/components/object-relations/AccessMatrix';
import {
  ACTIONS,
  CANDIDATES,
  INITIAL_DICTIONARY,
  INITIAL_GRANTS,
  ROLES,
  RELATIONS_HOME,
} from '../object-relations/model';
import { Code, Section } from './Section';
export function ObjectRelationsSection() {
  useGalleryAnchor('object-relations');
  return (
    <Section
      id="object-relations"
      title="Связи, справочники и доступ"
      lead="Общий контекст объектов: связанные записи, вложенность, управляемые значения и явные права."
    >
      <div className="grid min-w-0 items-start gap-6 xl:grid-cols-3">
        <div className="min-w-0 rounded-lg border border-line bg-card p-5">
          <RelatedObjects objects={CANDIDATES.slice(0, 2)} candidates={CANDIDATES} readOnly />
          <p className="mt-4">
            <Code>RelatedObjects · ObjectHierarchy</Code>
          </p>
        </div>
        <div className="min-w-0 rounded-lg border border-line bg-card p-5">
          <DictionaryEditor entries={INITIAL_DICTIONARY.slice(0, 3)} readOnly />
          <p className="mt-4">
            <Code>DictionaryEditor</Code>
          </p>
        </div>
        <div className="min-w-0 space-y-4 rounded-lg border border-line bg-card p-5">
          <ObjectVisibility roles={ROLES.slice(0, 2)} grants={INITIAL_GRANTS} />
          <AccessMatrix
            roles={ROLES.slice(0, 2)}
            actions={ACTIONS.slice(0, 2)}
            grants={{ owner: ['view', 'comment'], editor: ['view', 'comment'] }}
            readOnly
          />
          <p className="mt-4">
            <Code>AccessMatrix · ObjectVisibility</Code>
          </p>
        </div>
      </div>
      <Link
        to={RELATIONS_HOME}
        className="inline-flex w-fit items-center gap-2 rounded-sm text-sm font-medium text-brand-fg hover:underline focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
      >
        Открыть рабочий образец
        <ArrowRight className="size-4" />
      </Link>
    </Section>
  );
}
